export default __webpack_public_path__ + "static/media/Refin_Osmos_CENERE_60X120_In&Out.081c5d36.jpg";